import { h } from 'preact';

export function IconHeartOutline({
  width = 25,
  height = 20,
  fill = 'currentColor',
  onClick = undefined,
  ...rest
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="icon-heart-outline"
      onClick={onClick}
      {...rest}
    >
      <path
        d="M22.3828 2.55624C19.5605 0.1832 15.2002 0.539645 12.5 3.28867C9.7998 0.539645 5.43945 0.178317 2.61719 2.55624C-1.05468 5.64706 -0.517572 10.6861 2.09961 13.357L10.6641 22.0826C11.1523 22.5806 11.8066 22.859 12.5 22.859C13.1982 22.859 13.8477 22.5855 14.3359 22.0875L22.9004 13.3619C25.5127 10.691 26.0596 5.65195 22.3828 2.55624ZM21.2305 11.7115L12.666 20.4371C12.5488 20.5543 12.4512 20.5543 12.334 20.4371L3.76953 11.7115C1.98731 9.89511 1.62598 6.45761 4.12598 4.35312C6.02539 2.75644 8.95508 2.9957 10.791 4.86581L12.5 6.60898L14.209 4.86581C16.0547 2.98593 18.9844 2.75644 20.874 4.34824C23.3691 6.45273 22.998 9.90976 21.2305 11.7115Z"
        fill={fill}
      />
    </svg>
  );
}
